// src/pages/Login.js

import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import "./Login.scss";
import { useContext, useEffect, useState } from "react";
import { MemberContext } from "../Contexts/MemberContext";
import { useAuth } from "../Contexts/AuthContext";

const Login = () => {
  const { membersList, membersLoading } = useContext(MemberContext);
  const { setIsAuth } = useAuth();
  const navigate = useNavigate();

  const [googleUserId, setGoogleUserId] = useState(null);

  // -----------------------------
  // Google ログイン処理
  // -----------------------------
  const loginWithGoogle = async () => {
    try {
      const result = await signInWithPopup(auth, new GoogleAuthProvider());
      const user = result.user;

      if (!user) {
        alert("ログイン情報を取得できませんでした。再度試してください。");
        return;
      }

      setIsAuth(true);
      setGoogleUserId(user.uid); // 後処理は useEffect で行う
    } catch (error) {
      console.error("Googleログイン中にエラー:", error);
      alert("ログインに失敗しました。時間をおいて再度お試しください。");
    }
  };

  // -----------------------------
  // Google ログイン後のメンバー照合処理
  // membersList が揃ってから判定する
  // -----------------------------
  useEffect(() => {
    if (!googleUserId) return; // ログインしていない
    if (membersLoading) return; // Firestore 読み込み中
    if (!Array.isArray(membersList)) return;

    const matchedUser = membersList.find(
      (member) => member.author?.id === googleUserId
    );

    if (matchedUser) {
      navigate("/eventlist");
    } else {
      alert("あなたはメンバー情報が登録されていません。登録をお願いします。");
      navigate("/membercreate");
    }
  }, [googleUserId, membersLoading, membersList, navigate]);

  // -----------------------------
  // メールログイン / 新規登録
  // -----------------------------
  const handleEmailLogin = () => navigate("/emaillogin");
  const redirectToSignupForm = () => navigate("/signupform");

  return (
    <div className="container-login">
      <div className="content">
        <p>Googleアカウントでログイン</p>
        <button className="login-button" onClick={loginWithGoogle}>
          Googleでログイン
        </button>
      </div>

      <div className="content">
        <p>メールアドレスでログイン</p>
        <button className="login-button" onClick={handleEmailLogin}>
          メールアドレスでログイン
        </button>
      </div>

      <div className="content">
        <p>新規登録</p>
        <button className="login-button" onClick={redirectToSignupForm}>
          新規登録
        </button>
      </div>
    </div>
  );
};

export default Login;
